// Datas de Ponto Estratégico — Calendário Epidemiológico 2026.
// Formato: "mês_indice-dia" (janeiro = mês 0).
// Fonte única de verdade — usada por CalendarioEpidemiologico.tsx e PontoEstrategicoPE.tsx.
export const PE_DATES = new Set<string>([
  '0-4',  '0-18',         // Janeiro
  '1-1',  '1-15',         // Fevereiro
  '2-1',  '2-15', '2-29', // Março
  '3-12', '3-26',         // Abril
  '4-10', '4-24',         // Maio
  '5-7',  '5-21',         // Junho
  '6-5',  '6-19',         // Julho
  '7-2',  '7-16', '7-30', // Agosto
  '8-13', '8-27',         // Setembro
  '9-11', '9-25',         // Outubro
  '10-8', '10-22',        // Novembro
  '11-6', '11-20',        // Dezembro
]);

export function isPEDate(d: Date): boolean {
  return PE_DATES.has(`${d.getMonth()}-${d.getDate()}`);
}

export function proximaDataPE(hoje: Date = new Date()): Date | null {
  const hojeNorm = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
  for (let ano = hoje.getFullYear(); ano <= hoje.getFullYear() + 1; ano++) {
    const candidatas: Date[] = [];
    PE_DATES.forEach((chave) => {
      const [m, d] = chave.split('-').map(Number);
      candidatas.push(new Date(ano, m, d));
    });
    candidatas.sort((a, b) => a.getTime() - b.getTime());
    const proxima = candidatas.find((d) => d.getTime() >= hojeNorm.getTime());
    if (proxima) return proxima;
  }
  return null;
}

export function fmtDataPE(d: Date | null): string {
  if (!d) return '—';
  return d.toLocaleDateString('pt-BR');
}
